<div class="content">
  <div class="content__header">
    <div class="content__header__logo w-64">
      <img src="assets/images/logos/field_logo.svg" />
    </div>
    <h1 class="content__header__title">
      <span> {{ 'NET_PROMOTER_SCORE.COMMENT_STEP.TITLE_1' | translate }} </span>
      <span> {{ 'NET_PROMOTER_SCORE.COMMENT_STEP.TITLE_2' | translate }} </span>
    </h1>
  </div>
  <div class="content__container">
    <fc-text-area-input
      class="content__container__input"
      [label]="'NET_PROMOTER_SCORE.COMMENT_STEP.INPUT_LABEL' | translate"
      [control]="commentForm"
      [requiredMark]="false"
      [maxLength]="300"
    >
    </fc-text-area-input>
  </div>

  <button mat-flat-button (click)="nextStep()" color="primary" type="button" class="content__next_button">
    {{ 'NET_PROMOTER_SCORE.BUTTONS.SEND' | translate }}
  </button>
</div>
